import { fetchData } from '@databases/database-state';
import { Content, KnownUser, SearchResult, Space } from '@databases/types/confluence';

import { nextPagination } from '../pagination';

import { rejectOnError } from './utils';

export function searchConfluence<T extends Content | KnownUser | Space>(
  cql: string,
  expand: string[] = [],
  limit = Infinity
): AsyncGenerator<SearchResult<T>, void, void> {
  return nextPagination<SearchResult<T>>(
    async (url) => {
      const res = await fetchData(
        url ??
          `/rest/api/search?${new URLSearchParams({
            cql,
            expand: expand.map((e) => `content.${e}`).join(','),
            limit: `${Math.min(200, limit)}`,
          })}`
      ).then(rejectOnError);
      return await res.json();
    },
    { limit }
  );
}
